<template>
    <slot></slot>
</template>
<script setup>
import gsap from 'gsap';
import { Flip } from "gsap/Flip";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { onMounted } from 'vue';
import debounce from "lodash/debounce"

gsap.registerPlugin(Flip, ScrollTrigger);
let flipAnimation = null;
let stick = null;
let wbf = null;
let productCard = null;
let desktop = false;
const flipAnim = () => {
    const state = Flip.getState(stick, {props:['transform','top', 'left']});
    wbf.appendChild(stick);

    flipAnimation = Flip.from(state, {
        scrollTrigger:{
            id:'flip-trigger',
            trigger:'.top-section',
            start: () => {
                return 'top top+=' + (document.querySelector('header.main').offsetHeight + 1);
            },
            end: () => {
                const style = window.getComputedStyle(document.querySelector('.wbf'));
                return '+=' + (document.querySelector('.product-card').offsetHeight + (parseInt(style.marginTop, 10) * 2));
            },
            scrub:true
        },
        prune:true,
        scale:true,
        simple:true
    });
}

onMounted(() => {
    productCard = document.querySelector('.product-card .images')
    stick = productCard.querySelector('img.stick');
    wbf = document.querySelector('.wbf .stick-wrap');
    let lastWidth = window.outerWidth;

    if(window.outerWidth >= 768){
        flipAnim();
        desktop = true;
    } else {
        wbf.appendChild(stick);
    }



    window.addEventListener('resize', debounce(() => {
        if(window.outerWidth < 768 && desktop && window.outerWidth != lastWidth){
            flipAnimation.pause(0).kill(true);
            ScrollTrigger.getById('flip-trigger').kill(true);
            wbf.appendChild(stick);
            gsap.set(stick, {clearProps:true});
            desktop = false;
            lastWidth = window.outerWidth;
        } else if(window.outerWidth >= 768 && window.outerWidth != lastWidth){
            if(desktop){
                flipAnimation.pause(0).kill(true);
                ScrollTrigger.getById('flip-trigger').kill(true);
                productCard.appendChild(stick);
            }
            gsap.set(stick, {clearProps:true});
            flipAnim();
            desktop = true;
        }
    }, 300), true)
});

</script>
